import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DialogService } from '../../../services/modal-dialogs';
import { TOSSettingItemDialog } from '../../../dialogs/tos.setting.item/tos.setting.item.dialog';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ssApiService } from '../../../services/ss-api.service';
import { TOSIPArray, TOSIP, TOSIPTypes } from '../../../models/domain/tos.ip';
import { TOSMacArray } from '../../../models/domain/tos.mac';
import { TOSActivityLogResponseArray } from '../../../models/ss-api/responses/tos.activity.log.response';
import { MemberActivityLogsRequest } from '../../../models/ss-api/requests/member.activity.logs.request';
import { EditTOSIPRequest, EditTypes } from '../../../models/ss-api/requests/edit.tos.ip.request';
import { WindowSettings } from '../../../../app/services/window-dialogs/window.settings';
import { WindowTypes } from '../../../../app/services/window-dialogs/window.event';
import { WindowService } from '../../../../app/services/window-dialogs/window.service';
import { TOSComputer, TOSMemberComputer, TOSMemberComputerArray } from '@models/domain/tos.computer';

@Component({
    selector: 'tos',
    templateUrl: './tos.component.html',
    styleUrls: ['./tos.component.scss']
})
export class TOSComponent implements OnInit {

    @Input('IsBusy') IsBusy: boolean;
    @Input('MemberID') MemberID: number;
    @Output('onRefresh') onRefresh: EventEmitter<string> = new EventEmitter();

    TOSIPSettings: TOSIPArray;
    TOSIPWhitelist: TOSIPArray;
    TOSComputers: TOSMemberComputerArray = new TOSMemberComputerArray();
    TOSComputersWhitelisted: TOSMemberComputerArray = new TOSMemberComputerArray();

    TOSMACSettings: TOSMacArray;

    // Audit Logs
    HasSearchedAudits: boolean = false;

    AuditLogs: TOSActivityLogResponseArray;
    AuditLogStartDate: Date = new Date;
    AuditLogEndDate: Date = new Date;


    constructor(private api: ssApiService, private dialogService: DialogService, private sweetAlertService: SweetAlertService, private windowService: WindowService) { }

    ngOnInit() {

        this.getTOSSettings();
        this.AuditLogStartDate.setTime(this.AuditLogStartDate.getTime() - (24 * 60 * 60 * 1000) * 150); // subtract 30 days

    }

 
    onLicenseClick(key: string): void {
        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        this.windowService.OpenWindow<string>(WindowTypes.License, key, windowSettings);
    }

    async getTOSSettings() {
        this.IsBusy = true;
        await this.api.GetTOSMemberFlaggedIPs(this.MemberID).toPromise().then(response => {
            this.TOSIPSettings = response.Data;
        });
        await this.api.GetTOSMemberWhitelistedIPs(this.MemberID).toPromise().then(response => {
            this.TOSIPWhitelist = response.Data;
        });

        await this.api.GetTOSFlaggedMacAddresses(this.MemberID).toPromise().then(response => {
            this.TOSMACSettings = response.Data;

        });

        await this.RefreshComputers();
       
        this.IsBusy = false;
    }

    async RefreshComputers(){
       
        await this.api.GetTOSMemberComputers(this.MemberID).toPromise().then(reponse => {
            console.log("Computers: ", reponse);

            if (reponse.Data != undefined && reponse.Data != null){

                this.TOSComputers = new TOSMemberComputerArray();
                this.TOSComputersWhitelisted = new TOSMemberComputerArray();

                reponse.Data.forEach(x=>
                    {
                        if (x.IsWhitelisted)
                            this.TOSComputersWhitelisted.push(x);
                        else
                            this.TOSComputers.push(x);
                    });
            }

        });
    }
         
    AddSetting() {
        let disposable = this.dialogService.addDialog(TOSSettingItemDialog, {
            title: 'Add',
            subTitle: 'Sub Title',
            isEdit: false,
            MemberID: this.MemberID
        }).subscribe(result => {
            disposable.unsubscribe();
            this.getTOSSettings();
        });
    }

    EditSetting(ItemID: number) {
        let disposable = this.dialogService.addDialog(TOSSettingItemDialog, {
            title: 'Edit',
            subTitle: 'Sub Title',
            isEdit: true,
            settingID: 0,
            MemberID: this.MemberID
        }).subscribe(result => {
            disposable.unsubscribe();
            console.log('TOS Setting Item EDIT Dialog ', result);
            // this.refreshCredits();
        });
    }

    async DeleteSetting(ItemID: number) {
        await this.sweetAlertService.swal(
            {
                title: 'Delete TOS Setting?',
                text: 'Are you sure you want to delete this TOS Setting?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes, delete setting!',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                preConfirm: () => {
                    // return this.api.AddCredit( request ).toPromise();
                }
            })
            .then(async (response: any) => {
                this.sweetAlertService.swal(
                    {
                        title: 'Success',
                        text: 'Setting Deleted',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then((response: any) => {

                    }, (dismiss) => {
                        return;
                    }); // keep this line to prevent promise error;
            }, (dismiss) => {
                return;
            })
            .catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {

                    }, (dismiss) => {
                        return;
                    }); // keep this line to prevent promise error;
            });
    }

    GetAuditLogs(reload: boolean = false) {
        if (this.HasSearchedAudits && !reload)
            return;

        this.IsBusy = true;

        this.HasSearchedAudits = true;

        let request = new MemberActivityLogsRequest();
        request.StartDate = this.AuditLogStartDate;
        request.EndDate = this.AuditLogEndDate;
        request.MemberID = this.MemberID;

        let disposable = this.api.GetTOSActivityLogsByMember(request).subscribe(response => {
            disposable.unsubscribe();
            this.AuditLogs = response.Data;
            this.IsBusy = false;
        }, error => {
            disposable.unsubscribe();
            this.IsBusy = false;
        });

    }

    Whitelist(Item: TOSIP) {
        this.IsBusy = true;

        let request = new EditTOSIPRequest;
        request.IP = Item.IP;
        request.EditType = EditTypes.ChangeType;
        request.ChangeToType = TOSIPTypes.Whitelist;

        let disposable = this.api.EditTOSIP(request).subscribe(response => {
            disposable.unsubscribe();
            this.IsBusy = false;
            this.getTOSSettings();
        }, error => {
            disposable.unsubscribe();
            this.IsBusy = false;
        });

    }

    Blacklist(Item: TOSIP) {
        this.IsBusy = true;

        let request = new EditTOSIPRequest;
        request.IP = Item.IP;
        request.EditType = EditTypes.ChangeType;
        request.ChangeToType = TOSIPTypes.Blacklist;

        let disposable = this.api.EditTOSIP(request).subscribe(response => {
            disposable.unsubscribe();
            this.IsBusy = false;
            this.getTOSSettings();
        }, error => {
            disposable.unsubscribe();
            this.IsBusy = false;
        });
    }

    async WhitelistComputer(Item: TOSMemberComputer) {

        await this.sweetAlertService.swal(
            {
                title: 'Whitelist Computer?',
                text: Item.Name,
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                preConfirm: () => {
                    this.IsBusy = true;
                    return this.api.WhitelistTOSComputer(Item).toPromise();
                }
            })
            .then(async (response: any) => {
                
                await this.RefreshComputers();
                this.IsBusy = false;
                

                this.sweetAlertService.swal(
                    {
                        title: 'Success',
                        text: 'Computer whitelisted',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then(async (response: any) => {

                    }, async (dismiss) => {
                        return;
                    }); // keep this line to prevent promise error;
            }, (dismiss) => {
                return;
            })
            .catch(error => {
                this.IsBusy = false;
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {

                    }, (dismiss) => {
                        return;
                    }); // keep this line to prevent promise error;
            });
    }

    async RemoveWhitelistComputer(Item: TOSMemberComputer) {

        await this.sweetAlertService.swal(
            {
                title: 'Remove Computer From Whitelist?',
                text: Item.Name,
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                preConfirm: () => {
                    this.IsBusy = true;
                    return this.api.RemoveWhitelistTOSComputer(Item).toPromise();
                }
            })
            .then(async (response: any) => {       
                
                await this.RefreshComputers();         
                this.IsBusy = false;

                this.sweetAlertService.swal(
                    {
                        title: 'Success',
                        text: 'Computer whitelisted',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then(async (response: any) => {

                    }, async (dismiss) => {
                        return;
                    }); // keep this line to prevent promise error;
            }, (dismiss) => {
                return;
            })
            .catch(error => {
                this.IsBusy = false;
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {

                    }, (dismiss) => {
                        return;
                    }); // keep this line to prevent promise error;
            });
    }

}
